import { useMemo } from 'react';
import classnames from 'classnames';
import { noop } from 'ui-components/default-props/noop';
import { BOXES } from '../constants';
import defineShipmentsTableStyle from './define-shipments-table/define-shipments-table.module.less';

export const useMapSelectedOptionsForDropdown = (products) =>
  products.map((product) => ({
    value: product.productId,
    text: `${product.name} ${product.sku}`,
    name: product.name,
    sku: product.sku,
  }));

const getBodyRowClassName = (productIndex, productsLength) => {
  return classnames({
    [defineShipmentsTableStyle['box-product-row']]: productIndex !== productsLength - 1,
  });
};

export const useDefineShipmentsTableData = ({ stepPayload, isReadOnly = false, isDisabledAddSkusButton = noop }) =>
  useMemo(() => {
    let cumulativeBoxCount = 0;

    const getBoxConfigWithIndex = (index) =>
      isReadOnly
        ? []
        : [
            {
              isHeader: true,
              boxNumber: index + 1,
              bodyRowClassName: defineShipmentsTableStyle['box-header-row'],
            },
          ];

    return stepPayload[BOXES].flatMap((box, index) => {
      const startBoxNumber = cumulativeBoxCount + 1;
      const endBoxNumber = cumulativeBoxCount + box.boxesPerConfig;

      const boxNumberDisplay = box.boxesPerConfig === 1 ? `${startBoxNumber}` : `${startBoxNumber}-${endBoxNumber}`;

      cumulativeBoxCount = endBoxNumber;

      return [
        ...getBoxConfigWithIndex(index),
        ...box.products.map((product, productIndex) => ({
          ...product,
          boxConfigurationId: box.boxConfigurationId,
          boxesPerConfig: box.boxesPerConfig,
          boxNumberDisplay: productIndex === 0 ? boxNumberDisplay : '',
          isLastProduct: productIndex === box.products.length - 1,
          isFirstProduct: productIndex === 0,
          bodyRowClassName: getBodyRowClassName(productIndex, box.products.length),
          isDisabledAddSkusButton: isDisabledAddSkusButton(box.boxConfigurationId),
        })),
      ];
    });
  }, [isDisabledAddSkusButton, isReadOnly, stepPayload]);
